import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import Tooltip from "@material-ui/core/Tooltip";
import SearchIcon from "@material-ui/icons/Search";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import Helmet from "react-helmet";
// import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  RightDrawer,
} from "../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../Actions/LanguageAction";
import defaultEmp from "../../../../../../Assets/Images/defaultEmp.svg";
import approvalWorkflowConcept from "../../../../../../Assets/Images/done.svg";
import deleteIcon from "../../../../../../Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import editIcon from "../../../../../../Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import createstore from "../../../../../../store";
import { getFormattedImageLink } from "../../../../../../Utils";
import { DateConversion } from "../../../../../../Utils/dates";
import "./ApprovalWorkflow.css";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  searchIcon: {
    maxWidth: "414px",
    // marginRight: "20px",
    border: "1px solid #d8d8d8",
    borderRadius: "4px",
    padding: "2px 10px",
  },
});
const shouldCallAPI = true;

function FormattedMessage (prop) {
  return <span>{prop.defaultMessage}</span>
}

class ApprovalWorkflowList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 15,
      offset: 0,
      fullcount: 0,
      page: 0,
      approvalWorkflowList: [],
      search: "",
      actionidList: "",
      searchValue: "",
      issearchvalue: false,
      message: "",
      permissions: { readOnly: false, editable: false },
      dataReceived: false,
    };

    this.handleScroll1 = this.handleScroll1.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("approvalworkflowlist");
    const { SubscriptionInfo } = createstore.getState();
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];
    this.setState({ ShortDateFormat });
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll1);
    window.scrollTo(0, 0);
    const [isTrue, permissions] = CheckActionPermission("approvalWorkflow");
    if (isTrue) {
      this.setState({ permissions }, () => this.GetApprovalWorkflowList());
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll1);
  }

  handleScroll1 = () => {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom + 30 >= Math.floor(window.innerHeight * 0.65)) {
      if (this.state.fullcount > this.state.offset) {
        this.setState(
          {
            offset: this.state.offset + this.state.limit,
          },
          () => this.GetApprovalWorkflowList(),
        );
      }
    }
  };

  HelperSliderFlag(side, flag, text, config) {
    // this.setState({ HelperSlider: flag })
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    // this.props.RightDrawer({ drawerdata: text, open: flag });
    this.props.RightDrawer({
      drawerdata: text,
      open: side,
      side: flag,
      configid: config,
    });
    // this.props.RightDrawer({ drawerdata: this.state.EmpList, open: flag });
  }

  GetApprovalWorkflowList() {
    const URL = `subscription/approvalworkflowpolicy/${this.state.offset}/${this.state.limit}`;
    instance.get(URL).then(
      (result) => {
        let approvalWorkflowList = [];
        const fullcount = result.data.result[0]
          ? result.data.result[0].fullcount
          : 0;
        result.data.result.length > 0
          ? (approvalWorkflowList = [
              ...this.state.approvalWorkflowList,
              ...result.data.result,
            ])
          : (approvalWorkflowList = this.state.approvalWorkflowList);
        this.setState({
          fullcount,
          approvalWorkflowList,
          tempList: approvalWorkflowList,
          dataReceived: true,
        });
        this.forceUpdate();
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  GetNumberOfEmp = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  ConfirmDelete(id) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.DeleteApprovalWorkflow(id)}
        >
          Yes
        </Button>,
        <Button key="key" color="inherit" size="small">
          No
        </Button>,
      ],
    });
  }

  DeleteApprovalWorkflow(id) {
    const that = this;
    instance.delete(`subscription/approvalworkflowpolicy/${id}`).then(
      () => {
        this.props.enqueueSnackbar("Deleted successfully", {
          variant: "success",
        });
        this.setState(
          {
            approvalWorkflowList: [],
            offset: 0,
            dataReceived: false,
          },
          () => {
            that.GetApprovalWorkflowList();
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  OnSearch(e) {
    const approvalWorkflowList = this.state.tempList.filter(
      (item) =>
        item.approvalworkflowpolicyname
          .toLowerCase()
          .search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      issearchvalue: true,
      approvalWorkflowList,
    });
  }

  render() {
    const { classes } = this.props;
    const language = this.props.Language.approvalworkflowlist;
    const fullcount = get(this.state, "approvalWorkflowList[0].fullcount", "");
    return (
      <Fragment>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <main className="content-outer-wrapper" onScroll={this.handleScroll1}>
            {
              // this.state.dataReceived && this.state.approvalWorkflowList.length > 0 &&
              this.state.dataReceived && (
                <div>
                  <Helmet>
                    <title>{headersList.Config.ApprovalWorkflow.header}</title>
                  </Helmet>
                  <div className={classes.root}>
                    {this.state.approvalWorkflowList &&
                    this.state.approvalWorkflowList.length < 1 &&
                    !this.state.issearchvalue ? (
                      <Grid
                        container
                        className="config-landing-content-container"
                      >
                        <Grid item xs={12} md={6} sm={12}>
                          <div className="text-align-left">
                            <h5>Concept of Approval workFlow</h5>
                            <p
                              style={{
                                color: "rgba(0, 0, 0, 0.38)",
                                fontSize: "0.875rem",
                                lineHeight: "1.46429em",
                                padding: "20px 20px 20px 0px",
                              }}
                            >
                              <span>
                                <FormattedMessage
                                  id="approvalWorkflowConcept"
                                  defaultMessage="Approval workflows are a powerful tool to manage the flow of requests which are generated in sumHR. During the routine HR lifecycle of an employee, there are going to be a variety of requests coming in for different reasons like employee data approvals, attendance update requests, leave applications, and much more."
                                />
                              </span>
                            </p>
                            {this.state.permissions.editable ? (
                              <div>
                                <Link to={`./approval_workflow/create`}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    type="button"
                                    className="createbutton"
                                  >
                                    CREATE
                                  </Button>
                                </Link>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <div className="right">
                            <img
                              src={approvalWorkflowConcept}
                              className="width80"
                            />
                          </div>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid container className="config-table">
                        <Divider light />
                        <Grid container className="">
                          <Grid item xs={12} md={4} sm={3}></Grid>
                          <Grid item xs={12} md={8} sm={8}>
                            <Grid container justify="flex-end" direction="row">
                              <div style={{ marginRight: 20 }}>
                                <FormControl
                                  className={`${classes.searchIcon} searchBox`}
                                >
                                  <Input
                                    placeholder="Search"
                                    style={{ height: 35 }}
                                    disableUnderline
                                    value={this.state.searchValue}
                                    fullWidth
                                    onChange={this.OnSearch.bind(this)}
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <SearchIcon color="disabled" />
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </div>
                              <Grid>
                                {this.state.permissions.editable ? (
                                  <div>
                                    <Link to={`./approval_workflow/create`}>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        type="button"
                                        className="btn createbutton"
                                      >
                                        {/* <FormattedMessage id="BtCreate" defaultMessage="create" /> */}
                                        Create
                                      </Button>
                                    </Link>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs={12} md={4} sm={3}>
                            <div className="table-status noOfResults">
                              <FormattedMessage
                                id="LbShowingAll"
                                defaultMessage="Showing all"
                              />
                              &nbsp;{fullcount}&nbsp;
                              {fullcount > 1 ? (
                                <FormattedMessage
                                  id="LbapprovalWorkFlowPolicy"
                                  defaultMessage="approval workflows"
                                />
                              ) : (
                                <FormattedMessage
                                  id="LbapprovalWorkFlowPolicySingle"
                                  defaultMessage="approval workflow"
                                />
                              )}
                            </div>
                          </Grid>
                        </Grid>

                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            sm={12}
                            className="padding-top-8"
                          >
                            <Table className="approvalWorkflow-table">
                              <thead>
                                <tr>
                                  <th>
                                    <FormattedMessage
                                      id="LbApprovalWorkFlowName"
                                      defaultMessage="Approval WorkFlow Name"
                                    />
                                  </th>
                                  <th>
                                    <FormattedMessage
                                      id="LbCreatedBy"
                                      defaultMessage="Created By"
                                    />
                                  </th>
                                  <th>
                                    <FormattedMessage
                                      id="LbAssignedEmployee"
                                      defaultMessage="Assigned Employee"
                                    />
                                  </th>
                                  <th>
                                    <FormattedMessage
                                      id="LbEdit"
                                      defaultMessage="Edit"
                                    />
                                  </th>
                                  <th>
                                    <FormattedMessage
                                      id="LbDelete"
                                      defaultMessage="Delete"
                                    />
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.approvalWorkflowList.map(
                                  (listItem, index) => (
                                    <tr key={index}>
                                      <td>
                                        <p className="small-dark-secondary">
                                          {listItem.approvalworkflowpolicyname}
                                        </p>
                                        <p className="small-dark-secondary">
                                          {DateConversion(
                                            listItem.addeddate,
                                            this.state.ShortDateFormat,
                                          )}
                                        </p>
                                      </td>
                                      <td>
                                        <div className="position-rel">
                                          <div>
                                            <Tooltip
                                              title={listItem.addedbyname}
                                              placement="bottom"
                                            >
                                              {listItem.addedbyimagepath ? (
                                                <img
                                                  className="team-img1 vertical-middle"
                                                  src={getFormattedImageLink(
                                                    listItem.addedbyimagepath,
                                                  )}
                                                  height="56"
                                                />
                                              ) : (
                                                <img
                                                  className="team-img1 vertical-middle"
                                                  src={defaultEmp}
                                                  height="56"
                                                />
                                              )}
                                            </Tooltip>{" "}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <Grid
                                          container
                                          justify="center"
                                          alignItems="center"
                                        >
                                          <div className="avtar-thumb-wrapper-small">
                                            {listItem.assignedEmployeeList
                                              .length > 0 ? (
                                              listItem.assignedEmployeeList.map(
                                                (emp) => (
                                                  <Tooltip
                                                    key="key"
                                                    title={emp.employeename}
                                                    placement="bottom"
                                                  >
                                                    <div
                                                      className={
                                                        this.GetNumberOfEmp(
                                                          listItem
                                                            .assignedEmployeeList[0]
                                                            .fullcount,
                                                        ) > 0
                                                          ? "avtar-thumb-blur"
                                                          : "avtar-thumb"
                                                      }
                                                    >
                                                      <Link
                                                        to={`./profile/${emp.employeeid}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <div className="avatar-wrapper-small">
                                                          {emp.imagepath ==
                                                          null ? (
                                                            <img
                                                              src={defaultEmp}
                                                              height="40"
                                                              className="team-avatar"
                                                            />
                                                          ) : (
                                                            <img
                                                              src={getFormattedImageLink(
                                                                emp.imagepath,
                                                              )}
                                                              height="40"
                                                              className="team-avatar"
                                                            />
                                                          )}
                                                        </div>
                                                      </Link>
                                                    </div>
                                                  </Tooltip>
                                                ),
                                              )
                                            ) : (
                                              <div>
                                                <p
                                                  className="small-dark-secondary"
                                                  style={{ paddingTop: 14 }}
                                                >
                                                  No Employee Assigned
                                                </p>
                                              </div>
                                            )}
                                          </div>
                                          {listItem.assignedEmployeeList
                                            .length > 0 ? (
                                            this.GetNumberOfEmp(
                                              listItem.assignedEmployeeList[0]
                                                .fullcount,
                                            ) > 0 ? (
                                              <div
                                                className="additional-count"
                                                onClick={this.HelperSliderFlag.bind(
                                                  this,
                                                  "right",
                                                  true,
                                                  "workFlow",
                                                  listItem.approvalworkflowpolicyid,
                                                )}
                                              >
                                                <span>
                                                  <div className="total-count-small">
                                                    +
                                                    {this.GetNumberOfEmp(
                                                      listItem
                                                        .assignedEmployeeList[0]
                                                        .fullcount,
                                                    )}
                                                  </div>
                                                </span>
                                              </div>
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            ""
                                          )}
                                        </Grid>
                                      </td>
                                      <td className="position-rel">
                                        {this.state.permissions.editable ? (
                                          <Link
                                            to={`./approval_workflow/${listItem.approvalworkflowpolicyid}`}
                                          >
                                            <img
                                              src={editIcon}
                                              className="cursour-pointer vertical-middle"
                                            ></img>
                                          </Link>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>
                                        {this.state.permissions.editable ? (
                                          <img
                                            src={deleteIcon}
                                            className="cursour-pointer vertical-middle"
                                            onClick={() =>
                                              this.ConfirmDelete(
                                                listItem.approvalworkflowpolicyid,
                                              )
                                            }
                                          ></img>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </Table>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </div>
                </div>
              )
            }
          </main>
        )}
      </Fragment>
    );
  }
}

ApprovalWorkflowList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ApprovalWorkflowList)));
